"use client";

import dynamic from "next/dynamic";

// GetStartedButton pulls in the full Firebase SDK (auth) just to check
// sign-in state, and it's rendered on every page via Header/MobileNav —
// deferring it into its own chunk keeps that weight off the initial bundle
// everywhere. The loading fallback matches the button's own default
// "not signed in" render exactly, so there's no visible flash/layout shift
// once the real component takes over.
const GetStartedButton = dynamic(() => import("./GetStartedButton"), {
  ssr: false,
  loading: () => (
    <button
      type="button"
      disabled
      aria-hidden="true"
      className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm dark:bg-white dark:text-slate-900"
    >
      Get Started <span aria-hidden="true">↗</span>
    </button>
  ),
});

export default GetStartedButton;
